import type { FrameBlockModel } from '@blocksuite/hive/model';
import type { Store } from '@blocksuite/hive/store';

export function getFrameBlock(doc: Store) {
  const blocks = doc.getBlocksByFlavour('hive:frame');
  return blocks.length !== 0 ? (blocks[0].model as FrameBlockModel) : null;
}
